export interface UserRole {
  id: string;
  name?: UserRoleName;
  description?: string;
  users?: User[] | null;
  archived?: boolean;
}

export enum UserRoleName {
  TraceAdmin = 'TraceAdmin',
  SupportAccess = 'SupportAccess',
  CompanyAdmin = 'CompanyAdmin',
}

export enum ApplicationModuleName {
  TracePhishing = 'TracePhishing',
}

export interface User {
  id?: string;
  firstName: string;
  lastName: string;
  title: string;
  phone: string;
  email: string;
  active: boolean;
  primaryAdmin: boolean;
  userRoles: UserRole[];
  userGroups?: UserGroup[];
}

export interface UserGroup {
  id?: string;
  name: string;
  description: string;
  isMaster?: boolean;
  company?: Company;
  users?: User[];
  archived?: boolean;
}

export interface Company {
  id?: string;
  name: string;
  address1: string;
  address2: string;
  address3: string;
  country: string;
  geographicalRegion: string;
  city: string;
  postalCode: string;
  sosCompanyId: string;
  dataRetentionExpirationDate: string;
  tracephishingFreeTrial: boolean;
  industry: Industry;
  companyApplicationModules: CompanyApplicationModule[];
  adminUser: User;
  active: boolean;
  archived: boolean;
  sosVideoClientId: string;
  vmQualysClientId: string | null;
  vmHostIdentificationMethod: string;
  vmQualysNetworkId: string | null;
  traceeducationCanAccessVimeoLibrary: boolean | null;
  requireMfa: boolean | null;
}

export interface Industry {
  id?: string;
  name: string;
}

export interface CompanyApplicationModule {
  id?: string;
  didCreateSchema?: boolean;
  applicationModule: ApplicationModule;
}

export interface ApplicationModule {
  id?: string;
  name: string;
  description?: string;
  apiEndpoint?: string;
  hasDbSchema?: boolean;
}

export interface DataFilter {
  name: string;
  displayName: string;
  filterType: string;
  sortedOrder: number;
  filterOptions: DataFilterOption[];
  maxValue: number | null;
  value: number | null;
}

export interface DataFilterOption {
  key: string;
  value: string;
  sortOrder: number;
}

export interface Auth0User {
  email: string;
  email_verified: boolean;
  user_id: string;
  // picture: string;
  // name: string;
  // nickname: string;
  given_name: string;
  family_name: string;
  created_at: string;
  updated_at: string;
  // identities
  app_metadata: AppMetadata;
  // user_metadata
  // last_ip: string;
  // last_login: string;
  // logins_count: number;
}

export interface AppMetadata {
  company_id: string;
  is_active: boolean;
  is_archived: boolean;
  legacy_user_id: string;
  phone_number?: string;
  support_access_company_id?: string;
  title?: string;
  user_group_ids: string[];
  user_role_ids: string[];
}
